import { resolveFileUrl } from '../../lib/files'
import type { BioItem } from './types'

export function bioItemImageUrl(item: BioItem): string {
  return resolveFileUrl('link_bio_items', item.id, item.image, item.updated)
}

export function normalizeBioLink(value: string): string {
  const link = value.trim()
  if (link.startsWith('/')) return link
  if (/^https?:\/\//i.test(link)) return link
  return `https://${link}`
}
